import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, reactive } from 'vue'
import UploadFile2 from "@/components/view/UploadFile2.vue";
import { useRoute, useRouter } from "vue-router";
import message from 'ant-design-vue/lib/message';
import { finishTask } from '@/api/home';
import {caseOrderDetail} from "@/api/patientCaseOrder";

export default /*#__PURE__*/_defineComponent({
  __name: 't36',
  setup(__props) {

const data = reactive({
  fileName: '',
  confirmLoading: false,
  imageUrl: '',
  orderDetail: {
      patientName: "",
      clinicName: "",
      dentistName: "",
      productName: "",
  },
})
const route = useRoute();
const router = useRouter();
onMounted(() => {
  data.fileName = `/${route.query.patientId}/7/${route.query.diagnosisOrderId}/origin/临床操作说明.pdf`;
    getInfo();
})
const onSuccess = (val: string) => {
  console.log(val);
  // data.imageUrl = data.fileName + val.substring(val.lastIndexOf('.'))
  data.imageUrl = val
}
const getInfo = ()=>{
    const patientCaseOrderId = route.query.patientCaseOrderId;
    caseOrderDetail(patientCaseOrderId).then((res: any)=>{
        console.log(res)
        data.orderDetail = res;
    })
}
const previewFile = ()=>{
    window.open(data.imageUrl)
}
const handleOk = () => {
  if (!data.imageUrl) {
    message.info('请上传临床操作说明！')
    return
  }
  data.confirmLoading = true;
  console.log("提交", route.query);
  let option = {
    processDefinitionId: route.query.processDefinitionId,
    processDefinitionKey: route.query.processDefinitionKey,
    processInstanceId: route.query.processInstanceId,
    runTimeTaskId: route.query.runTimeTaskId,
    taskCode: route.query.taskCode,
    dentistId: route.query.dentistId,
    oralDetectionId: route.query.oralDetectionOrderId,
    params: {
      patientCaseOrderId: route.query.patientCaseOrderId,
      informedConsentPath: data.imageUrl,
    },
  };
  finishTask(option).then(() => {
    data.confirmLoading = false;
    message.success("操作成功");
    router.push({
      path: "/home",
    });
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CloudUploadOutlined = _resolveComponent("CloudUploadOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              title: "订单资料",
              bordered: false,
              style: {"height":"300px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions, {
                  layout: "horizontal",
                  column: 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_descriptions_item, { label: "当前患者" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.orderDetail.patientName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "门诊" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.orderDetail.clinicName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "临床医生" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.orderDetail.dentistName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "医疗产品" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.orderDetail.productName), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              title: "上传临床操作说明",
              bordered: false,
              style: {"height":"300px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: 50 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(UploadFile2, {
                          onOnSuccess: onSuccess,
                          accept: ".pdf",
                          fileName: "临床操作说明.pdf",
                          path: data.fileName,
                          "bn-title": "点击上传临床操作说明"
                        }, null, 8, ["path"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          onClick: handleOk,
                          loading: data.confirmLoading
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_CloudUploadOutlined)
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" 提交 ")
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: previewFile,
                          disabled: !!!data.imageUrl
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("预览")
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})